const { useEffect } = require('react');

const useTitle = (title) => {
  useEffect(() => {
    document.title = `${title} - LM Patante`;
  }, [title]);
};

export default useTitle;
